import { Fragment, useState } from "react";
import { playOneAnimation, setAnimationFrame } from "src/services/animations";
import { useStore } from "src/store";
import { SubHotspot } from "src/types/index.d";
import playIcon from "src/assets/svg/play.svg";
import { Spacer } from "./dynamic.components";

const SubHotspots = ({
  sublinkId,
  content,
  buttonWidth = "medium",
}: {
  sublinkId: string;
  content?: { block: JSX.Element; contentIndex: number };
  buttonWidth?: "medium" | "large";
}) => {
  const [active, setActive] = useState(0);

  const {
    activeSubLink: { id, subHotspots },
    animationIsPlaying,
  } = useStore();
  if (sublinkId !== id) return null;

  const onClickSubHotspot = (subHotspot: SubHotspot, index: number) => {
    setActive(index);
    const { annotation, frame, animationSequences, animations } = subHotspot;
    if (frame) {
      setAnimationFrame({ annotation, frame });
    }
    if (animations?.length && animationSequences?.length) {
      const isReplay = index === active;
      const annot = isReplay ? "" : annotation;
      playOneAnimation(annot, animationSequences[0], true, true);
    }
  };

  return (
    <div>
      {subHotspots?.map((subHotspot, index) => (
        <Fragment key={subHotspot.name}>
          {subHotspot.content?.align === "top" && subHotspot.content.Block && (
            <subHotspot.content.Block />
          )}
          <button
            className={`button button--secondary button--xlarge ${
              "button--fixwidth-" + buttonWidth
            } ${active === index ? "button--hover" : ""} ${
              animationIsPlaying ? "button--disabled" : ""
            }`}
            onClick={() => onClickSubHotspot(subHotspot, index)}
            disabled={animationIsPlaying}
          >
            <span style={{ margin: "auto" }}>{subHotspot.name}</span>
            {subHotspot.animationSequences?.length && (
              <img
                className={`play-icon ${
                  index === active && animationIsPlaying
                    ? "play-icon-animate"
                    : ""
                }`}
                src={playIcon}
                alt="play animation"
              />
            )}
          </button>
          <Spacer />
          {subHotspot.content?.align !== "top" && subHotspot.content?.Block && (
            <subHotspot.content.Block />
          )}
          {content && content.contentIndex === index && content.block}
        </Fragment>
      ))}
    </div>
  );
};
export default SubHotspots;
